export const getRestrictedAdminMenuItems = (items) =>
  items.map((item) => {
    if (!item.isGroup) {
      return item
    }

    if (item.groupTitle === "Invoices & Prices") {
      return {
        ...item,
        groupTitle: "Prices",
        items: item.items.filter((groupItem) => groupItem.url !== "/invoices")
      }
    }

    if (item.groupTitle === "Analytics") {
      return {
        ...item,
        items: item.items.filter((groupItem) => groupItem.url !== "/marketing")
      }
    }

    return item
  })
